export * from './reach-slider.directive';
export * from './type';
